"use client";

import {JSX} from "react";

import Image from "next/image";
import Link from "next/link";

import {Typography} from "@/shared/ui/data-display/typography";
import {assetPath} from "@/shared/utils/asset-path";

import type {LocatedItem} from "./located-blocks-data";

interface Props {
    item: LocatedItem;
}

export function LocatedBlocksCard({item}: Props): JSX.Element {
    const phoneNumbers = item.phoneNumbers ?? [];
    return (
        <div className="located-blocks__card">
            <div className="located-blocks__card-content">
                <Typography as="h3" size={{desktop: 16, mobile: 16}} weight={600} className="located-blocks__city-title">
                    {item.name}
                </Typography>

                {phoneNumbers.map((entry, index) => {
                    const className = index === 0 ? "located-blocks__city-phone" : "located-blocks__city-toll";
                    return (
                        <Typography key={index} as="p" color="paragraph" size={{desktop: 12, mobile: 12}} weight={400} className={className}>
                            {entry.label && <span className="located-blocks__phone-label">{entry.label}</span>}
                            {entry.url ? (
                                <a href={entry.url} className="located-blocks__phone-link">
                                    {entry.text}
                                </a>
                            ) : (
                                <span>{entry.text}</span>
                            )}
                        </Typography>
                    );
                })}
            </div>

            {item.link ? (
                <Link href={item.link} className="located-blocks__arrow">
                    <Image src={assetPath("/images/located-blocks/arrow-right.svg")} alt="" width={24} height={24} className="located-blocks__icon" />
                </Link>
            ) : (
                <span className="located-blocks__arrow">
                    <Image src={assetPath("/images/located-blocks/arrow-right.svg")} alt="" width={24} height={24} className="located-blocks__icon" />
                </span>
            )}
        </div>
    );
}
